import { render, staticRenderFns } from "./EditConference.vue?vue&type=template&id=3ddce13a&"
import script from "./EditConference.vue?vue&type=script&lang=js&"
export * from "./EditConference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports